export enum DrawColor
{
    BLACK = 0x010101,
    BLUE = 0x4870ff,
    RED = 0xf91e01,
    YELLOW = 0xffe500,
    GREEN = 0x4cbb17,
    CYAN = 0x48ffc8,
    MAGENTA = 0xc241ff,
}
